import { Layout } from 'react-admin';

import CustomMenu from './CustomMenu';
import CustomAppBar from './CustomAppBar';
import HelpdeskWidget from '../misc/HelpdeskWidget';

/**
 * Sidebar + AppBar sabit; yatay/dikey scroll sadece içerik alanında.
 */
const CustomLayout = (props) => (
  <>
    <HelpdeskWidget />
    <Layout
      {...props}
      color="#AE256D"
      menu={CustomMenu}
      appBar={CustomAppBar}
      sx={{
        height: '100vh',
        maxWidth: '100vw',
        overflow: 'hidden',
        '& .RaLayout-appFrame': {
          height: '100%',
          maxWidth: '100vw',
          overflow: 'hidden',
          // RA default: marginTop for fixed AppBar — sticky AppBar ile üstte beyaz boşluk bırakır
          marginTop: '0 !important',
        },
        '& .RaLayout-contentWithSidebar': {
          display: 'flex',
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
        },
        '& .RaSidebar-root, & .RaSidebar-fixed, & .MuiDrawer-root, & .MuiDrawer-paper': {
          zIndex: 1201,
          flexShrink: 0,
        },
        '& .RaAppBar-root, & .MuiAppBar-root': {
          position: 'sticky',
          top: 0,
          zIndex: 1202,
          backgroundColor: '#AE256D !important',
          backgroundImage: 'none !important',
          color: '#fff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
        },
        '& .MuiAppBar-colorSecondary, & .MuiAppBar-colorPrimary': {
          backgroundColor: '#AE256D !important',
          color: '#fff',
        },
        '& .RaLayout-content': {
          flex: 1,
          minWidth: 0,
          maxWidth: '100%',
          overflowX: 'auto',
          overflowY: 'auto',
        },
      }}
    />
  </>
);

export default CustomLayout;
